// ============================================================================
// HINDI TRANSLATIONS - UI
// ============================================================================

import unityTranslations from './unity.js';
export const uiTranslations = {
  meta: {
    language: 'hi',
    languageName: 'हिन्दी',
    version: '1.0'
  },
  
  app: {
    title: "UNITYQUEST इतिहास\nप्रेम का",
    subtitle: "इंटरैक्टिव धर्मग्रंथ खोज",
    tagline: "दिव्य प्रकाश की ओर चलना",
    menu: "मेनू",
    retry: "पुनः प्रयास"
  },
  
  buttons: {
    play: "खेलें",
    back: "वापस",
    continue: "जारी रखें",
    restart: "पुनः आरंभ करें",
    close: "बंद करें",
    nextLevel: "अगला स्तर",
    selectLevel: "स्तर चयन",
    retry: "पुनः प्रयास करें",
    mainMenu: "मुख्य मेनू",
    start: "शुरू करें",
    cancel: "रद्द करें",
    confirm: "पुष्टि करें",
    save: "सहेजें",
    load: "लोड करें",
    yesRestart: "हाँ, पुनः आरंभ करें",
    noContinue: "नहीं, जारी रखें",
    tryAgain: "फिर से प्रयास करें",
    backToMenu: "मेनू पर वापस जाएं"
  },
  
  labels: {
    score: "स्कोर",
    stars: "सितारे",
    wisdom: "बुद्धि",
    revelation: "प्रकाशन",
    lives: "जीवन",
    combo: "कॉम्बो",
    level: "स्तर",
    easy: "आसान",
    medium: "मध्यम",
    hard: "कठिन",
    correct: "सही!",
    gameOver: "परीक्षण विफल",
    victory: "विजय!",
    completed: "पूर्ण",
    rank: "आध्यात्मिक रैंक",
    points: "ज्ञान अंक",
    unlockedLevels: "अनलॉक किए गए स्तर",
    questionOfKnowledge: "ज्ञान का प्रश्न",
    hintOfWisdom: "बुद्धि का संकेत",
    knowledgeMastered: "ज्ञान में महारत हासिल!",
    knowledgeAcquired: "ज्ञान प्राप्त!",
    testFailed: "परीक्षण विफल",
    wisdomBonus: "बोनस",
    xpGained: "XP",
    newRank: "नई रैंक"
  },
  
  menu: {
    playButton: "खेलें",
    info: "जानकारी",
    treasures: "खजाना",
    john: "यूहन्ना",
    reset: "रीसेट",
    restart: "🔄 रोमांच फिर से शुरू करें?",
    confirmReset: "क्या आप वाकई अपनी सारी प्रगति मिटाना चाहते हैं?",
    youWillLose: "आप खो देंगे:",
    wisdomPoints: "ज्ञान अंक",
    starsCollected: "एकत्रित सितारे",
    levelsUnlocked: "अनलॉक किए गए स्तर",
    spiritualRank: "आध्यात्मिक रैंक",
    newAdventure: "🎮 नया रोमांच",
    readyToStart: "शुरू करने के लिए तैयार हैं?",
    startJourney: "धर्मग्रंथों के ज्ञान में अपनी यात्रा शुरू करें!",
    audioControls: "ऑडियो नियंत्रण",
    mute: "म्यूट करें",
    unmute: "अनम्यूट करें",
    close: "बंद करें",
    language: "भाषा",
    restartGame: "गेम पुनः आरंभ करें"
  },
  
  login: {
    title: "UNITY QUEST",
    subtitle: "इंटरैक्टिव बाइबल रोमांच",
    anonymousMode: "गुमनाम खेलें",
    anonymousDesc: "एक उपनाम चुनें",
    emailMode: "ईमेल लॉगिन",
    emailDesc: "मल्टी-डिवाइस सेव",
    pseudo: "उपनाम",
    pseudoPlaceholder: "आपका उपनाम...",
    email: "ईमेल पता",
    emailPlaceholder: "aapka@email.com",
    startPlaying: "खेलना शुरू करें",
    sendLink: "लिंक भेजें",
    sending: "भेजा जा रहा है...",
    connecting: "कनेक्ट हो रहा है...",
    back: "वापस",
    localSave: "आपकी प्रगति स्थानीय रूप से सहेजी जाएगी",
    cloudSync: "कोई पासवर्ड आवश्यक नहीं • क्लाउड सिंक",
    magicLink: "ईमेल द्वारा एक जादुई लिंक प्राप्त करें",
    checkEmail: "✉️ अपना ईमेल जांचें! एक लॉगिन लिंक भेजा गया है।",
    checkSpam: "अपने स्पैम/जंक फ़ोल्डर की भी जांच करें",
    waitingConnection: "कनेक्शन की प्रतीक्षा में...",
    errorSend: "लिंक भेजने में त्रुटि",
    rateLimited: "⏳ ईमेल फिर से भेजने से पहले कृपया 15 सेकंड प्रतीक्षा करें",
    importSession: "🔄 प्रोडक्शन से सत्र आयात करें",
    errorConnection: "कनेक्शन त्रुटि",
    enterPseudo: "कृपया एक उपनाम दर्ज करें",
    enterEmail: "कृपया एक मान्य ईमेल दर्ज करें",
    // Tooltips
    never: "कभी नहीं",
    save: "गेम सहेजें",
    lastSave: "अंतिम",
    refresh: "प्रगति पुनः लोड करें",
    logout: "लॉग आउट",
    connectToCloud: "ऑनलाइन सहेजने के लिए कनेक्ट करें",
    editPseudo: "उपयोगकर्ता नाम संपादित करें",
    confirm: "पुष्टि करें",
    cancel: "रद्द करें",
    close: "बंद करें",
    passwordMode: "सरल लॉगिन",
    passwordDesc: "ईमेल + पासवर्ड",
    password: "पासवर्ड",
    passwordPlaceholder: "न्यूनतम 6 वर्ण",
    passwordMinLength: "न्यूनतम 6 वर्ण",
    playWithoutAccount: "खाते के बिना खेलें",
    forgotPassword: "पासवर्ड भूल गए?",
    resetPasswordTitle: "पासवर्ड रीसेट करें",
    resetPasswordSubtitle: "रीसेट लिंक प्राप्त करने के लिए अपना ईमेल दर्ज करें",
    sendResetLink: "लिंक भेजें",
    resetEmailSent: "📧 रीसेट ईमेल भेजा गया! अपना इनबॉक्स जांचें।",
    errorReset: "ईमेल भेजने में त्रुटि",
    backToSignin: "साइन इन पर वापस जाएं",
    newPassword: "नया पासवर्ड",
    enterNewPassword: "एक नया सुरक्षित पासवर्ड चुनें",
    confirmPassword: "पासवर्ड की पुष्टि करें",
    updatePassword: "पासवर्ड अपडेट करें",
    passwordsDontMatch: "पासवर्ड मेल नहीं खाते",
    passwordUpdateSuccess: "✅ पासवर्ड सफलतापूर्वक अपडेट किया गया!",
    errorUpdatePassword: "पासवर्ड अपडेट करते समय त्रुटि",
    resetLinkExpired: "रीसेट लिंक समाप्त हो गया या अमान्य है",
    forgotPassword: "पासवर्ड भूल गए?",
    signup: "साइन अप करें",
    signin: "साइन इन करें",
    createAccount: "खाता बनाएँ",
    signupInfo: "नीचे दिया गया फॉर्म भरें",
    passwordInfo: "पासवर्ड के साथ त्वरित पहुंच",
    signupButton: "मेरा खाता बनाएँ",
    signinButton: "साइन इन करें",
    passwordTooShort: "पासवर्ड कम से कम 6 वर्णों का होना चाहिए",
    emailAlreadyExists: "यह ईमेल पहले से उपयोग में है",
    emailExistsHint: "✉️ यह ईमेल पहले से पंजीकृत है। साइन इन करने का प्रयास करें! (शायद किसी अन्य गेम से बनाया गया?)",
    switchToSignin: "🔑 अपने मौजूदा ईमेल के साथ साइन इन मोड पर स्विच करें",
    invalidCredentials: "अमान्य ईमेल या पासवर्ड",
    signupSuccess: "📧 खाता बनाया गया! अपने पंजीकरण की पुष्टि करने के लिए अपना ईमेल जांचें।",
    emailConfirmationRequired: "अपने खाते को सक्रिय करने के लिए अपना इनबॉक्स जांचें",
    checkSpamFolder: "अपने स्पैम/जंक फ़ोल्डर की जांच करना याद रखें",
    connectionSuccess: "✅ सफलतापूर्वक लॉगिन हुआ!",
    errorSignup: "साइन अप के दौरान त्रुटि"},
  
  install: {
    title: "ऐप इंस्टॉल करें",
    subtitle: "त्वरित पहुँच और ऑफ़लाइन",
    feature1: "अपनी होम स्क्रीन से तुरंत लॉन्च करें",
    feature2: "इंस्टॉलेशन के बाद ऑफ़लाइन काम करता है",
    feature3: "नेटिव ऐप अनुभव",
    feature4: "स्टोर डाउनलोड की आवश्यकता नहीं",
    install: "इंस्टॉल करें",
    dismiss: "बाद में",
    info: "आप किसी भी समय ऐप को अनइंस्टॉल कर सकते हैं"
  },
  
  ranks: {
    seeker: "खोजी",
    believer: "जागृत",
    disciple: "शिष्य",
    servant: "सेवक",
    witness: "साक्षी",
    guardian: "संरक्षक",
    wise: "बुद्धिमान",
    prophet: "नबी",
    apostle: "प्रेरित",
    seekerDesc: "आध्यात्मिक यात्रा की शुरुआत",
    believerDesc: "जागृत आध्यात्मिक चेतना",
    discipleDesc: "शिक्षाओं को सीखना",
    servantDesc: "सेवा और भक्ति",
    witnessDesc: "विश्वास साझा करना",
    guardianDesc: "सत्य की रक्षा",
    wiseDesc: "ज्ञान और बुद्धि",
    prophetDesc: "आध्यात्मिक दृष्टि",
    apostleDesc: "आध्यात्मिक गुरु"
  },

  spiritualJourney: {
    beginning: "आध्यात्मिक यात्रा की शुरुआत",
    progress: "आध्यात्मिक प्रगति",
    grade: "ग्रेड",
    xp: "XP",
    level: "स्तर",
    nextGrade: "अगला ग्रेड",
    still: "अभी भी",
    maxLevelReached: "अधिकतम स्तर प्राप्त किया!",
    masteredAllTeachings: "आपने सभी शिक्षाओं में महारत हासिल कर ली है",
    progression: "प्रगति"
  },
  
  treasures: {
    title: "💎 बाइबल के खजाने",
    verse: "दिन का पद",
    fact: "क्या आप जानते हैं?",
    treasure: "छिपा हुआ खजाना",
    question: "मजेदार सवाल",
    context: "संदर्भ",
    strongReference: "गहन अध्ययन के लिए बाइबिल संदर्भ",
    emmanuelMemo: "इमैनुएल का ज्ञापन",
    emmanuelMessage: "आप पहाड़ की चोटी पर पहुंच गए हैं, और ज्ञान प्राप्त हो गया है। लेकिन अटूट विश्वास के लिए जीवन के अनुभव, दया और यीशु के सच्चे प्रेम की आवश्यकता होती है। जीवन की विभिन्न परीक्षाएं आपके रास्ते का परीक्षण करेंगी, वह सच्चा मार्ग जिसे हम चुनते हैं, हमारे दिल का। हम अपूर्ण रहते हैं, हमारी इच्छाएं अनेक हैं, और लाभ या हमारे व्यक्तिगत आराम का प्यार अक्सर हमारी स्वार्थी प्राथमिकता बन जाता है। परमेश्वर से बुद्धि, उसका प्रेम, उसकी शक्ति मांगें, और विनम्रता से अपनी कमजोरियों को स्वीकार करें, क्योंकि उससे कुछ भी छिपाया नहीं जा सकता... कुछ भी नहीं। निजी मोड में यात्रा करने, वीपीएन का उपयोग करने या इतिहास हटाने की कोई आवश्यकता नहीं है। दानिय्येल की तरह उपवास करें: शांति और बुद्धि में, जो आप सबसे ज्यादा प्यार करते हैं उससे एक पल के लिए खुद को वंचित करें। यह आपको परमेश्वर को बेहतर सुनने की अनुमति देगा, गहरे - और अक्सर दर्दनाक - परिवर्तनों के लिए तैयार हृदय का स्वभाव होगा। तब सपने और दर्शन स्पष्ट हो जाएंगे, जैसे यूसुफ के लिए। लेकिन अभिमान से सावधान रहें: 'मैं हमेशा सही हूं' या 'मुझे बेहतर पता है' में न आएं। क्योंकि परमेश्वर का प्रकटीकरण एक असाधारण अनुग्रह है। व्यवस्था के डॉक्टर न बनें, जो आज फिर से यीशु को क्रूस पर चढ़ाने में सक्षम हैं, वह जो केवल अपने पड़ोसी से प्यार करने के लिए कहते हैं... और उन्हें वही स्वतंत्रता प्रदान करें जो आप प्राप्त करते हैं। विश्वास रखना एक संबंध में प्रवेश करना और हृदय की एक स्वतंत्र यात्रा है। यह आपको शक्तिशाली नायक बना देगा, असंभव के सक्षम। क्योंकि अलौकिक का अनुभव, परमेश्वर की उपस्थिति, उसकी पुष्टि या आशीर्वाद आपको वास्तव में अटूट बना देगा।",
    clarification: "महत्वपूर्ण स्पष्टीकरण",
    bibleOffline: "बाइबल ऑफ़लाइन पढ़ें",
    bibleStudy: "बाइबिल अध्ययन",
    version: "संस्करण",
    openReader: "रीडर खोलें",
    features: "विशेषताएं"
  },
  
  messages: {
    chooseCard: "⚡ अपना शक्ति कार्ड चुनें",
    cardHelp: "यह इस स्तर के 3 प्रश्नों के लिए आपके साथ रहेगा",
    chooseAnswer: "📖 अपना उत्तर चुनें:",
    wrongAnswer: "❌ गलत उत्तर! आपके पास {lives} जीवन बचे हैं। फिर से प्रयास करें!",
    levelCompleted: "स्तर {level} पूर्ण",
    questionsProgress: "प्रश्न {current} का {total}",
    starsCollected: "एकत्रित सितारे: {current}/{total}",
    pointsEarned: "+{points} ज्ञान अंक",
    secondChance: "⚔️ आपका साहस कार्ड आपको दूसरा मौका देता है! बुद्धि से फिर प्रयास करें।",
    bonusApplied: "✨ {card} बोनस: +{percent}% ({base} → {final})",
    defeatedQuote: "मैं मसीह द्वारा सब कुछ कर सकता हूं",
    perfect: "✨ पूर्ण",
    good: "⭐ अच्छा",
    start: "⭐ शुरुआत",
    secretLevel: "🎺 गुप्त स्तर अनलॉक!",
    secretChapter: "🏆 गुप्त अध्याय",
    returnToLevels: "वापसी",
    next: "अगला",
    retry: "पुनः प्रयास करें",
    menu: "मेनू",
    chapter: "अध्याय",
    chapterStars: "अध्याय के सितारे",
    totalGlobal: "कुल वैश्विक",
    backToMenu: "मेनू पर वापस"
  },
  
  chapters: {
    "1": "उत्पत्ति",
    "2": "निर्गमन",
    "3": "यीशु मसीह",
    "4": "क्रूस पर चढ़ाना/पुनरुत्थान",
    "5": "प्रारंभिक चर्च",
    "6": "पौलुस के मिशन",
    "7": "पत्र/प्रकाशितवाक्य",
    "8": "बोनस स्तर"
  },
  
  cards: {
    faith: "विश्वास",
    courage: "साहस",
    wisdom: "ज्ञान",
    faithKnowledge: "+50% अंक",
    courageKnowledge: "दूसरा मौका",
    wisdomKnowledge: "संकेत + बोनस",
    faithDesc: "प्राप्त ज्ञान अंकों की अधिकतम संख्या",
    courageDesc: "सामान्य अंक लेकिन दूसरा मौका",
    wisdomDesc: "संकेत प्रकट और +25% अंक",
    chooseCard: "✨ अपना ज्ञान कार्ड चुनें",
    cardEffects: "✨ ज्ञान कार्ड के प्रभाव:",
    faithEffect: "+50% ज्ञान अंक - अधिकतम पुरस्कार",
    courageEffect: "सामान्य अंक लेकिन त्रुटि पर दूसरा मौका",
    wisdomEffect: "+25% अंक + प्रत्येक प्रश्न के लिए संकेत प्रकट",
    chooseWisely: "बुद्धिमानी से चुनें, क्योंकि आपकी पसंद पूरे स्तर में आपके साथ रहेगी"
  },
  
  challenge: {
    loading: "स्तर लोड हो रहा है...",
    peace: "🕊️ शांति आपके घर में बसे",
    questionsAwaiting: "💡 3 ज्ञान के प्रश्न आपकी प्रतीक्षा कर रहे हैं",
    starsQuote: "हर सितारा दिव्य प्रकाश की ओर एक कदम है"
  },
  
  info: {
    title: "Unity Quest शांति के इतिहास",
    subtitle: "धर्मग्रंथों की इंटरैक्टिव खोज",
    yourStats: "आपके आंकड़े",
    score: "स्कोर",
    wisdom: "बुद्धि",
    revelation: "प्रकाशन",
    createdWith: "❤️ के साथ बनाया गया",
    creator: "इमैनुएल पायेट",
    developerPassionate: "आध्यात्मिकता के प्रति उत्साही डेवलपर",
    artistModule: "इमैनुएल कलाकार",
    artistPortfolio: "कलात्मक पोर्टफोलियो और डिजिटल रचनाएँ",
    features: "विशेषताएं",
    multipleChapters: "8 बाइबिल अध्यायों में फैले 91 स्तर",
    powerCards: "3 अद्वितीय शक्ति कार्ड (विश्वास, साहस, ज्ञान)",
    progressionSystem: "आध्यात्मिक रैंक के साथ प्रगति प्रणाली",
    bibleTreasures: "बाइबिल के खजाने और रोचक तथ्य",
    howToPlay: "कैसे खेलें",
    selectLevel: "एक अनलॉक स्तर चुनें",
    choosePowerCard: "अपना शक्ति कार्ड चुनें",
    answerQuestions: "3 ज्ञान के प्रश्नों का उत्तर दें",
    earnStars: "अपने शेष जीवन के आधार पर सितारे अर्जित करें",
    tips: "टिप्स",
    readCarefully: "प्रत्येक प्रश्न को ध्यान से पढ़ें",
    useWisdomCard: "संकेत के लिए ज्ञान कार्ड का उपयोग करें",
    courageGivesSecondChance: "साहस कार्ड आपको दूसरा मौका देता है",
    faithMaximizes: "विश्वास कार्ड आपके अंकों को अधिकतम करता है",
    johnGospelTitle: "यूहन्ना का सुसमाचार",
    johnGospelStats: "21 अध्याय • 878 पद • 14 भाषाएँ",
    bibleReaderStrong: "बाइबल रीडर + Strong",
    bibleReaderStrongDesc: "Strong शब्दकोश के साथ पूर्ण पठन",
    johnTreasures: "यूहन्ना के खजाने",
    johnTreasuresDesc: "बाइबल के खजाने और रोचक तथ्य",
    quickAccessChapters: "प्रसिद्ध अध्यायों तक त्वरित पहुँच:",
    johnChapter1: "प्रस्तावना",
    johnChapter3: "नया जन्म",
    johnChapter14: "मैं मार्ग हूँ",
    johnChapter20: "पुनरुत्थान",
    version: "संस्करण",
    madeWithLove: "परमेश्वर की महिमा के लिए प्रेम से बनाया गया",
    backToMenu: "मेनू पर वापस"
  },
  
  bible: {
    readerTitle: "📖 बाइबिल रीडर",
    johnReaderTitle: "बाइबिल रीडर - यूहन्ना का सुसमाचार",
    john: "यूहन्ना",
    loading: "धर्मग्रंथ लोड हो रहे हैं...",
    loadingChapter: "यूहन्ना के सुसमाचार का अध्याय {chapter}। पूर्ण डेटा लोड हो रहा है...",
    exploreWhileLoading: "इस बीच, आप अन्य अध्यायों का अन्वेषण कर सकते हैं या खोज फ़ंक्शन का उपयोग कर सकते हैं।",
    menu: "मेनू",
    tabBible: "बाइबिल",
    tabUnity: "एकता",
    strong: "स्ट्रॉन्ग",
    strongReferences: "स्ट्रॉन्ग संदर्भ",
    verses: "पद",
    previous: "पिछला",
    next: "अगला",
    strongDefinition: "स्ट्रॉन्ग संदर्भ",
    word: "मूल शब्द",
    transliteration: "लिप्यंतरण",
    pronunciation: "उच्चारण",
    meaning: "अर्थ",
    definition: "पूर्ण परिभाषा",
    usage: "बाइबिल उपयोग",
    etymology: "व्युत्पत्ति",
    close: "बंद करें",
    moreReferences: "और {{count}} अन्य संदर्भ",
    copyright: "📖 लुई सेगोंड 1910 - सार्वजनिक डोमेन • स्ट्रॉन्ग नंबर शामिल",
    shareVerse: "इस पद को साझा करें",
    markAsRead: "अंश पढ़ लिया",
    alreadyRead: "पहले से पढ़ा",
    readingBonus: "पढ़ने का बोनस",
    results: "परिणाम",
    result: "परिणाम",
    copy: "कॉपी करें",
    image: "छवि"
  },
  
  mountain: {
    spiritualAscension: "आध्यात्मिक आरोहण",
    levelProgress: "स्तर {{level}} • {{stars}} सितारे प्राप्त",
    combo: "कॉम्बो",
    perfectMessage: '"क्योंकि मेरे विचार तुम्हारे विचार नहीं हैं" - मेमना पूर्ण बुद्धि की ओर चढ़ता है',
    goodMessage: '"खोजो और तुम पाओगे" - सत्य की ओर आरोहण जारी है',
    startMessage: '"विश्वास, राई के दाने जितना छोटा भी" - प्रकाश की ओर पहला कदम',
    skipAnimation: "एनीमेशन छोड़ें",
    chapter: "अध्याय",
    chapterProgress: "अध्याय {{current}}/{{total}}",
    secret: "रहस्य",
    waypoints: {
      start: "शुरुआत",
      firstSlope: "पहली ढलान",
      lastSlope: "आखिरी ढलान"
    },
    status: {
      defeat: "हार",
      inProgress: "प्रगति में"
    }
  },
  
  bibleResources: {
    inAppReader: {
      name: "ऐप में पढ़ें",
      description: "Strong के साथ एकीकृत बाइबिल रीडर",
      features: {
        offline: "ऑफ़लाइन",
        strong: "Strong नंबर",
        navigation: "नेविगेशन"
      }
    }
  },
  
  quotes: {
    wisdom: "सच्चा ज्ञान शाश्वत बुद्धि की ओर ले जाता है",
    faith: "मैं मसीह के द्वारा जो मुझे सामर्थ देता है सब कुछ कर सकता हूं",
    hope: "यहोवा मेरा चरवाहा है, मुझे किसी चीज की कमी न होगी",
    love: "क्योंकि परमेश्वर ने जगत से ऐसा प्रेम रखा...",
    perseverance: "विश्वास के लिए दृढ़ता की आवश्यकता होती है",
    defeat: "असफलता ज्ञान में वृद्धि के लिए आमंत्रित करती है"
  },

  unity: unityTranslations,

  philosophy: {
    title: "दार्शनिक आयाम",
    loveOntology: "एक सत्तामीमांसीय सिद्धांत के रूप में प्रेम",
    loveDescription: "यीशु प्रेम को एक आध्यात्मिक नींव में बदल देते हैं: परमेश्वर और दूसरों से प्यार करना प्रामाणिक अस्तित्व की संरचना ही बन जाती है। प्रेम नैतिकता से परे जाकर अस्तित्व का एक तरीका बन जाता है।",
    newCommandment: "नई आज्ञा",
    jesusEmphasizes: "जब यीशु एक नई आज्ञा देते हैं, तो वे प्रेम करने की क्रिया पर जोर देते हैं",
    loveGod: "अपने परमेश्वर से अपने पूरे दिल से प्रेम करो",
    loveNeighbor: "अपने पड़ोसी से अपने समान प्रेम करो",
    lovePriority: "प्रेम एक प्राथमिकता बन जाता है"
  },

  footer: {
    version: "संस्करण 1.0 • 2024",
    dedication: "परमेश्वर की महिमा के लिए विकसित"
  },

  endCredits: {
    lines: [
      { text: "आप पहाड़ की चोटी पर पहुंच गए हैं", delay: 2000 },
      { text: "आपने बहुत कुछ सीखा है", delay: 2000 },
      { text: "आपका विश्वास हर दिन बढ़ता है", delay: 2000 },
      { text: "आप परमेश्वर के साथ सुंदर चीजें अनुभव करते हैं", delay: 2000 },
      { text: "कठिनाइयाँ आपको बढ़ने में मदद करती हैं", delay: 2000 },
      { text: "वे दिखाती हैं कि क्या महत्वपूर्ण है", delay: 2000 },
      { text: "एक छोटे बच्चे की तरह विनम्र बनें", delay: 2000 },
      { text: "परमेश्वर आपके सरल दिल से प्यार करते हैं", delay: 2000 },
      { text: "शांति में आप परमेश्वर को सुनते हैं", delay: 2000 },
      { text: "उपवास आपकी आत्मा को मुक्त करता है", delay: 2000 },
      { text: "प्रार्थना करें और परमेश्वर आपका मार्गदर्शन करेंगे", delay: 2000 },
      { text: "अभिमान सत्य को छिपाता है", delay: 2000 },
      { text: "परमेश्वर का अनुग्रह शानदार है", delay: 2000 },
      { text: "यह परमेश्वर के दिल से आता है", delay: 2000 },
      { text: "सच्चा विश्वास आपको स्वतंत्र बनाता है", delay: 2000 },
      { text: "यह आपको हमेशा के लिए परमेश्वर से जोड़ता है", delay: 2000 },
      { text: "प्रेम सब कुछ बदल सकता है", delay: 2000 },
      { text: "यह चमत्कार कर सकता है", delay: 2000 },
      { text: "मेरे साथ दोहराएं", delay: 2000 },
      { text: "यीशु, मैं आपको अपना दिल देता हूं", delay: 3000 },
      { text: "आप मेरे राजा हैं, मेरे उद्धारकर्ता", delay: 3000 },
      { text: "आओ और मेरे जीवन को बदलो", delay: 3000 },
      { text: "यात्रा अब जारी है", delay: 2000 },
      { text: "इस सुंदर प्रकाश को साझा करें", delay: 2000 },
      { text: "उस जीवन की ओर जो कभी समाप्त नहीं होता", delay: 2000 },
      { text: "अपने दिल में प्रेम रखें", delay: 3000 },
      { text: "एक अमूल्य खजाने की तरह", delay: 3000 }
    ],
    finalMessages: {
      congratulations: "बधाई हो!",
      proud: "हमें आप पर गर्व है",
      courage: "साहसी योद्धा",
      peace: "शांति के वाहक",
      child: "परमेश्वर की संतान",
      blessing: "परमेश्वर आपको आशीष दें",
      continue: "जारी रखें"
    }
  },

  validation: {
    pseudoTooShort: "उपनाम में कम से कम 2 वर्ण होने चाहिए",
    enterPseudo: "कृपया एक उपनाम दर्ज करें"
  },

  pseudoSetup: {
    title: "अपना खिलाड़ी उपनाम चुनें",
    confirm: "उपनाम की पुष्टि करें"
  },

  navigation: {
    back: "वापस"
  },

  console: {
    starsUnlocked: "सितारे पहुंच गए! अध्याय अनलॉक",
    defeatAnimation: "हार... जे.सी. नीचे जाता है"
  },

  errors: {
    progressionError: "प्रगति त्रुटि",
    invalidProgressionData: "अमान्य प्रगति डेटा:"
  },

  levels: {
    chaptersAndBonus: "8 अध्याय + बोनस स्तर",
    bonusUnlocked: "🏆 बोनस स्तर अनलॉक! आपने आध्यात्मिक पूर्णता हासिल की है!",
    starsToDiscover: "खोजने के लिए 273 {stars}",
    starsPerLevel: "प्रति स्तर 3 {stars}"
  },

  architecture: {
    title: "🔧 तकनीकी वास्तुकला",
    react: {
      name: "React",
      description: "आधुनिक इंटरफ़ेस"
    },
    modules: {
      name: "मॉड्यूल",
      description: "गतिशील लोडिंग"
    },
    localStorage: {
      name: "LocalStorage",
      description: "स्थानीय भंडारण"
    },
    tailwind: {
      name: "Tailwind",
      description: "उत्तरदायी डिज़ाइन"
    }
  },

  gameManager: {
    title: "गेम सेव",
    saveLocal: "स्थानीय सेव",
    saveCloud: "क्लाउड सिंक्रनाइज़",
    saveWaiting: "कनेक्शन की प्रतीक्षा में",
    lastSave: "अंतिम सेव:",
    never: "कभी नहीं",
    saving: "सहेजा जा रहा है...",
    save: "सहेजें",
    loadProgress: "लोड करें",
    loading: "लोड हो रहा है...",
    autoSaveEnabled: "💾 ऑटो-सेव सक्षम",
    saveError: "❌ सेव त्रुटि",
    gameSaved: "✅ गेम सहेजा गया!",
    gameLoaded: "📥 गेम लोड किया गया!"
  }
};

export default uiTranslations;
